export default __webpack_public_path__ + "static/media/ProductSans-Black.afb0618b.woff";